import {budgetLineProblem,budgetPennies,budgetPeriod} from '@myfm/domain';
import type {BudgetEditorLine} from './BudgetCostTable';

export type BudgetEditorProblem={field:string;message:string;row?:number};
export function budgetEditorProblems(input:{reason:string;label:string;reserve:string;sectionName:string;interim?:{startsOn:string;endsOn:string};lines:BudgetEditorLine[];split?:{commercialReserveContribution:string}}):BudgetEditorProblem[]{
 const problems:BudgetEditorProblem[]=[];
 const add=(field:string,message:string,row?:number)=>problems.push({field,message,...(row===undefined?{}:{row})});
 if(input.reason.trim().length<3)add('Amendment reason','Enter a reason of at least 3 characters before previewing. Your edits are retained.');
 if(input.label.trim().length<2)add('Budget title','Enter a budget title of at least 2 characters.');
 if(!input.split&&!input.sectionName.trim())add('Budget section name','Enter a section name.');
 for(const [field,value]of [['Reserve contribution',input.reserve],...(input.split?[['Commercial reserve contribution',input.split.commercialReserveContribution]]:[])]){
  try{budgetPennies(value!)}catch{add(field!,'Use a non-negative amount with at most two decimal places.')}
 }
 if(input.interim)try{budgetPeriod(input.interim.startsOn,input.interim.endsOn)}catch(e){add('Budget dates',(e as Error).message)}
 if(!input.lines.length)add('Budget costs','Add at least one expenditure line.');
 input.lines.forEach((line,index)=>{
  const row=index+1;
  if(!line.description.trim())add(`Row ${row} description`,'Enter a description.',index);
  if(input.split&&!line.splitRuleId)add(`Row ${row} who contributes`,'Choose Residential, Commercial or a shared allocation.',index);
  try{const problem=budgetLineProblem(line);if(problem)add(`Row ${row} amount and details`,problem,index)}catch(e){add(`Row ${row} amount and details`,(e as Error).message,index)}
 });
 return problems;
}
